<template>
  <div id="app">
    <!-- 侧边栏 -->
    <Sidebar v-if="!isBlankLayout" />
    
    <!-- 主要内容区域 -->
    <div :class="['main-container', { 'with-sidebar': !isBlankLayout }]">
      <router-view />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'App',
  components: {
    Sidebar
  },
  setup() {
    const route = useRoute()
    const isBlankLayout = computed(() => route.meta?.layout === 'blank')
    
    return {
      isBlankLayout
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

.main-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.main-container.with-sidebar {
  margin-left: 260px;
  padding: 0;
}

/* 登录页面样式 */
.blank-main {
  padding: 0!important;
  background: transparent;
  min-height: 100vh;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-container.with-sidebar {
    margin-left: 0;
  }
}
</style>
